export const labelHelper = (text?: string, maxLength = 45) => {
  if (text && text?.length <= maxLength) return text;
  return text?.slice(0, maxLength - 3) + '...';
};
